import { useRef } from 'react';
import { enUS as en, ru } from 'date-fns/locale';
import { FormControl, FormHelperText, FormLabel, IconButton } from '@mui/material';
import { CalendarToday, Clear } from '@mui/icons-material';
import { DateTimeField, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { withControl } from '@features/effector-form/hoc/withControl';
import { getSafePickerLocale } from '@shared/utils/getSafePickerLocale';
import { theme } from '@unicorn/bms-theme';

const EN = 'en';
const LNG = localStorage.getItem('lang') || EN;

export const DateTimeControl = withControl(
  ({ value, setValue, error, label, required, readOnly, disabled, isError }) => {
    const inputRef = useRef(null);

    return (
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={LNG === EN ? en : ru}
        localeText={getSafePickerLocale(LNG)}
      >
        <FormControl required={required} disabled={disabled}>
          {label && <FormLabel error={isError}>{label}</FormLabel>}
          <DateTimeField
            value={value}
            onChange={(newValue) => setValue(newValue)}
            inputRef={inputRef}
            InputProps={{
              readOnly,
              disabled,
              endAdornment: (
                <>
                  {!readOnly && !!value && (
                    <IconButton
                      size="small"
                      onClick={() => {
                        setValue(null);

                        if (!inputRef.current) return;

                        (inputRef.current as HTMLInputElement).focus();
                      }}
                    >
                      <Clear fontSize="small" />
                    </IconButton>
                  )}
                  {!readOnly && (
                    <CalendarToday
                      fontSize="small"
                      sx={{ color: theme.palette.action.active }}
                    />
                  )}
                </>
              ),
            }}
            size="small"
            readOnly={readOnly}
            disabled={disabled}
          />
          {error && <FormHelperText error>{error}</FormHelperText>}
        </FormControl>
      </LocalizationProvider>
    );
  }
);
